<script lang="ts">
import { $inj } from "@/common/decorators/depinject";
import LanguageFactory from "@/common/services/Language/LanguageFactory";
import { defineComponent } from "vue";
import '@banno/jha-wc/src/cards/jha-card/jha-card';

export default defineComponent({
  name: "bltCard",
  props: {
    headerText: {
      type: String
    },
    headerIcon: {
      type: String
    },
    bltUiText: {
      type: String
    }
  },
  setup() {
    const languageFactory = $inj(LanguageFactory);
    return {
      languageFactory
    };
  },
  data() {
    return {
      headerTitle: "" as string
    };
  },
  created() {
    if (this.headerText) this.headerTitle = this.headerText;
    else if (this.bltUiText) {
      this.languageFactory.get(this.bltUiText).then((text) => {
        this.headerTitle = text;
      });
    }
  }
});
</script>
<template>
  <jha-card v-bind:title="headerTitle" class="jha-card-base">
    <div class="jh-card-header jh-card-header-position">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <slot name="body"></slot>
    </div>
    <div class="card-footer">
      <slot name="footer"></slot>
    </div>
  </jha-card>
</template>
<style>
:root {
  --jh-card-footer-space-padding: 0px;
}

.jha-card-base {
  padding: var(--jh-space-200) var(--jh-space-600) var(--jh-space-500) var(--jh-space-600);
}

.jh-card-header {
  color: var(--jha-color-dark);
  font: var(--jh-font-weight-500) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
  min-height: 48px;
  align-items: center;
}
</style>
